module.exports = __webpack_public_path__ + "img/legendary_attunement_image.04b98c18.png";